import React from 'react'

export const AdminDashboard : React.FC = () => {
    return (
        <>
        </>
    )
}
